import { PAGE_HOST_KIND } from '~common';
import { PAGE_HOST } from '~configs';
import { ENV_STRIPE_KEY, getStripePromise } from '~configs/stripe';
import { useTenantContext } from '~providers/TenantProvider';
import { TenantInfo } from '~types';

type StripeConfig = {
  publishableKey: string;
  stripeAccount?: string;
};

export const resolveStripeConfig = (
  pageHostKind: PAGE_HOST_KIND,
  tenant: TenantInfo | null,
  envKey: string | undefined,
): StripeConfig | null => {
  const tenantKey = tenant?.stripe?.publishableKey;
  if (tenantKey) {
    return {
      publishableKey: tenantKey,
      stripeAccount: tenant?.stripe?.stripeAccount,
    };
  }
  if (pageHostKind === PAGE_HOST_KIND.TENANT || !envKey) {
    return null;
  }
  return { publishableKey: envKey };
};

export const useStripePromise = () => {
  const { tenant } = useTenantContext();
  const config = resolveStripeConfig(PAGE_HOST.kind, tenant, ENV_STRIPE_KEY);

  return config
    ? getStripePromise(config.publishableKey, config.stripeAccount)
    : null;
};
